export default [
    {
        content: "恭喜“小森林”喜提“牛气冲天”台历一本",
    },
    {
        content: "恭喜“周星星”喜提“达哥防跳水”马克杯一个",
    },
    {
        content: "恭喜“大大泡泡卷”获得“神棍局”情绪宝(7天)阅读权限",
    },
    {
        content: "恭喜“阿呆”获得“道达牛指”(30天)阅读权限",
    },
    {
        content: "恭喜“AAAA地产小张”喜提“达哥安全垫”抱枕一个",
    },
    {
        content: "恭喜“CoCo”喜提“20cm”笔记本一个",
    },
    {
        content: "恭喜“该你背时”获得“每日夜报”(30天)阅读权限",
    },
    {
        content: "恭喜“东北吴彦祖”喜提“牛气冲天”台历一本",
    },
    {
        content: "恭喜“月亮之上”喜提“达哥安全垫”抱枕一个",
    },
    {
        content: "恭喜“不好意思同花大顺”获得“神棍局”情绪宝(7天)阅读权限",
    },
    {
        content: "恭喜“牛萌萌就是猛”获得“道达牛指”(30天)阅读权限",
    },
    {
        content: "恭喜“你过来呀”喜提“20cm”笔记本一个",
    },
    {
        content: "恭喜“红掌拨清波”获得“神棍局”情绪宝(30天)阅读权限",
    },
    {
        content: "恭喜“凉叫兽”喜提“达哥防跳水”马克杯一个",
    },
    {
        content: "恭喜“SeLaVi”喜提“牛气冲天”台历一本",
    },
    {
        content: "恭喜“木子李”获得“神棍局”情绪宝(7天)阅读权限",
    },
    {
        content: "恭喜“辣目娜扎”获得“每日夜报”(30天)阅读权限",
    },
    {
        content: "恭喜“施主你会唱小星星吗”获得“道达牛指”(30天)阅读权限",
    },
    {
        content: "恭喜“行走的雪媚娘”喜提“20cm”笔记本一个",
    },
];
